// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type EditFilterModalType from './index.tsx';

const RLLAsyncEditFilterModal = lazyForPaint(
	() => import(/* webpackChunkName: "async-edit-filter-modal" */ './index'),
);

const RLLAsyncEditFilterModalContainer = (
	props: JSX.LibraryManagedAttributes<
		typeof EditFilterModalType,
		ComponentProps<typeof EditFilterModalType>
	>,
): React.JSX.Element => (
	<Placeholder name="edit-filter-modal" fallback={<></>}>
		<RLLAsyncEditFilterModal {...props} />
	</Placeholder>
);

export default RLLAsyncEditFilterModalContainer;
